import type { EventOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { LocalDate } from '../../../utilities/local-date';
import { getDoneUpdatedText } from './get-done-updated-text';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';

export function eventDoneText(
  item: EventOccurrenceViewModel,
  doneByOptions: SelectDropdownOption[],
  singleUserVersion: boolean,
  includeUpdated: boolean = false,
) {
  if (!item.doneDate) {
    return '';
  }
  const doneDate = LocalDate.fromString(item.doneDate);
  const doneUpdatedAt = LocalDate.fromString(item.doneUpdatedAt);
  let doneBy = '';
  let doneUpdatedText = '';
  if (!singleUserVersion) {
    let doneByUuid = item.doneByEmployeeUuid ?? '';
    if (item.doneByContactPersonUuid) {
      doneByUuid = item.doneByContactPersonUuid;
    }
    let doneUpdatedByUuid = item.doneUpdatedByEmployeeUuid ?? '';
    if (item.doneUpdatedByContactPersonUuid) {
      doneUpdatedByUuid = item.doneUpdatedByContactPersonUuid;
    }
    const doneByOption = doneByOptions.find((o) => {
      return o.value === doneByUuid;
    });
    if (doneByOption) {
      doneBy = ' av ' + doneByOption.text;
    }
    if (includeUpdated) {
      doneUpdatedText = getDoneUpdatedText(doneDate, doneUpdatedAt, doneByUuid, doneUpdatedByUuid, doneByOptions);
    }
  }
  return doneDate.toStringForDisplay() + doneBy + doneUpdatedText;
}
